(function () {
  const labels = window.heliumCustomerFieldsI18n;
  if (!labels) return;

  const fieldKeys = Object.keys(labels);

  function localizeField(input) {
    const key = input.getAttribute('data-cf-column-key') || input.getAttribute('name');
    if (!key || !labels[key]) return;

    const text = labels[key];
    const field = input.closest('.cf-field');
    const label = field && field.querySelector('label');

    if (label) label.textContent = text;
    input.setAttribute('placeholder', text);
  }

  function localizeAll(root) {
    root = root || document;
    fieldKeys.forEach(function (key) {
      root.querySelectorAll('.cf-field input[name="' + key + '"]').forEach(localizeField);
    });
  }

  function init() {
    localizeAll();

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && (node.matches('.cf-field') || node.querySelector('.cf-field'))) {
            localizeAll(node);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
